export const SIZE_S = "screen and (min-width: 640px)";
export const SIZE_M = "screen and (min-width: 768px)";
export const SIZE_L = "screen and (min-width: 1024px)";
export const SIZE_XL = "screen and (min-width: 1280px)";
export const SIZE_XXL = "screen and (min-width: 1536px)";

export const COLOR_BLACK = "#000000";
export const COLOR_SHADOW = `${COLOR_BLACK}60`;
export const COLOR_WHITE = "#ffffff";
export const BORDER_RADIUS_DEFAULT = "0.6rem";

export const COLOR_GRAY_DARK = "#606266";
export const COLOR_GRAY_LIGHT = "#C4C4C4";
export const COLOR_GRAY_LIGHTER = "#E6E6E6";

export const COLOR_BLUE_DARK = "#0D4CD6";
export const COLOR_BLUE_LIGHT = "#0A74FF";
export const COLOR_BLUE_LIGHTER = "#4797FF";

export const COLOR_GREEN = "#1F9C64";
export const COLOR_RED = "#FF472D";
export const COLOR_PURPLE = "#916FF8";
export const COLOR_YELLOW = "#EEBC4B";
export const COLOR_PINK = "#FF00E5";

export const FOOTER_HEIGHT = 55;

export const COOKIE_CONSENT_NAME = "fp-consent";
export const COOKIE_CONSENT_VALUE = "all";
